import * as actionTypes from 'modules/audits/actionTypes';
import { OPEN_AUDITS_IMPORT_MODAL } from 'modules/interventions/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

const initialState = [];

const setIds = (state, { payload, meta }) => {
  if (meta?.source === 'link-audit') {
    return [...state, ...payload.content.map(audit => audit.id)];
  }
  return state;
};

const clearIds = () => initialState;

const auditsRequest = (state, { meta }) => (meta?.source === 'link-audit' && meta?.reset ? [] : state);

export default createReducer(initialState, {
  [actionTypes.FETCH_AUDITS_REQUEST]: auditsRequest,
  [actionTypes.FETCH_AUDITS_SUCCESS]: setIds,
  [actionTypes.CLEAR_COLLECTION]: clearIds,
  [OPEN_AUDITS_IMPORT_MODAL]: clearIds,
});
